<template>
  <el-cascader
    clearable
    :style="{ width: width }"
    :size="size"
    :options="deptTree"
    :show-all-levels="false"
    :props="cascProps"
    filterable
    placeholder="请选择"
    :disabled="disabled"
    v-model="department"
  ></el-cascader>
</template>

<script>
import { getGoodsCategoryTreeAPI } from './api'
export default {
  name: 'SelectDept',

  props: {
    value: {
      type: [String, String],
      default: ''
    },
    size: {
      type: String,
      default: 'small'
    },
    width: {
      type: String,
      default: ' 250px'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    department: {
      get() {
        return this.value
      },

      set(val) {
        this.$emit('input', val)
      }
    }
  },

  data() {
    return {
      deptTree: [],
      cascProps: {
        label: 'name',
        value: 'id',
        checkStrictly: true,
        expandTrigger: 'hover',
        emitPath: false,
        multiple: false,
        leaf: 'leaf'
      }
    }
  },

  created() {
    this.getTree()
  },

  methods: {
    async getTree() {
      let res = await getGoodsCategoryTreeAPI()
      this.deptTree = this.setLeaf(res)
    },

    setLeaf(list) {
      return list.map(item => {
        if (item.children && item.children.length > 0) item.children = this.setLeaf(item.children)
        else {
          item.leaf = true
          delete item.children
        }
        return item
      })
    }
  }
}
</script>

<style></style>
